import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { round } from '../../../../assets/js/components/frontend/util'

// initial state
// import { state } from '%/store/addressbook.js'
// import { state } from '%/store/all2another.js'
/**/ import { state } from './modules/index.js'

// getters
const getters = {
    /**
     * Base products with ordered list of child products
     * @param state
     */
    products: state => state.catalog,

    /**
     * To provide a component with a data source in form of notation xxxx[prodId].children[childId]
     * @param state
     * @returns {*|state.catalog}
     */
    childProducts: function (state) {
        var cat = Object.assign({}, state.catalog);
        for (var pid in cat) {
            var newChildren = {};
            cat[pid].children.forEach(function (item) {
                var itemId = 'item_id' in item ? item.item_id : 0;
                if (itemId > 0) {
                    newChildren[itemId] = item;
                }
            });
            cat[pid].children = Object.assign({}, newChildren);
        }
        return cat;
    },

    /**
     * To provide a component with a list of all known dependent line items in notation xxxx[childId]
     * @param state
     * @returns {*|state.catalog}
     */
    baseProductChildren: function (state) {
        var output = {};
        for (var productItemId in state.catalog) {
            var children = state.catalog[productItemId]['children'] || [];
            for (var index in children) {
                if ('item_id' in children[index]) {
                    output[children[index]['item_id']] = {
                        item_id: children[index]['item_id'],
                        // parent_id: productItemId,
                        // price: children[index]['price'],
                        description: children[index]['description']
                    };
                }
            }
        }
        return output;
    },

    /**
     * To provide a component with a list of all known shippable line items in notation xxxx[childId]
     * @param state
     * @returns {*|state.catalog}
     */
    baseProductShippableChildren: function (state) {
        var output = {};
        for (var productItemId in state.catalog) {
            ['children', 'parts', 'kscerts'].map((key) => {
                var children = state.catalog[productItemId][key] || [];
                for (var index in children) {
                    if ('item_id' in children[index]) {
                        output[children[index]['item_id']] = {
                            item_id: children[index]['item_id'],
                            description: children[index]['description']
                        };
                    }
                }
            });
        }
        return output;
    },

    /**
      * Number of unique items in the shopping cart
      * @param state
     */
    cartItemsCount: state => state.isOrderCompleted ? 0 : state.items.length,

    /**
     * Shopping Cart
     * @param state
     */
    cart: state => state.items,
    isOrderCompleted: state => state.isOrderCompleted,
    countries: state => state.countries,
    regions: state => state.regions,

    marketing: state => state.marketing,

    // address/shipping related
    shipTo: state => state.shipTo,
    billing: state => state.addresses[state.billingAddressId],
    promo: state => state.promo,
    shippingAddresses: state => {
        var output = {};
        Object.keys(state.addresses).forEach(idx => {
            // console.log(idx, state.billingAddressId);
            if (idx.toString() !== state.billingAddressId.toString()) {
                output[idx] = state.addresses[idx];
            }
        });
        return output;
    },
    /* all */ addresses: state => state.addresses,
    addressMap: state => state.addressMap,

    // quantities of each catalog item for each cart position
    qtys: state => {
        var output = {};
        if (state.items.length > 0) {
            for (var itemIndex in state.items) {
                var position = state.items[itemIndex];
                if ('item_id' in position && position.item_id > 0) {
                    if ('children' in position /* && position.gc == false */) {
                        for (var itemId in position.children) {
                            var qty = +position.children[itemId];
                            // qty += this.getFreeKeepsakeCertCount(itemId);
                            if (qty > 0) {
                                if (!(itemIndex in output)) {
                                    output[itemIndex] = {};
                                }
                                output[itemIndex][itemId] = qty;
                            }
                        }
                    }
                }
            }
        }
        return output;
    },

    hasShippableItems: state => {
        var itemsCount = 0;
        var cart = state.items;
        if (cart.length > 0) {
            for (var itemIndex in cart) {
                var position = cart[itemIndex];
                if ('item_id' in position && position.item_id > 0) {
                    if ('gc' in position && position.gc === true) {
                        itemsCount++;
                    } else {
                        var itemId = position.item_id;
                        var product = itemId in state.catalog ? state.catalog[itemId] : {};
                        if ('item_gets_shipped' in product && product.item_gets_shipped === true) {
                            // fulfillment item or composite item containing a paver inside
                            itemsCount++;
                        }
                        if ('kscerts' in product) {
                            for (var partIndex in product.kscerts) {
                                var part = product.kscerts[partIndex];
                                if ('item_gets_shipped' in part && part['item_gets_shipped']) {
                                    itemsCount++;
                                }
                            }
                        }
                        if ('children' in position) {
                            for (let itemId in position.children) {
                                var qty = +position.children[itemId];
                                itemsCount += qty;
                            }
                        }
                    }
                }
            }
        }
        return itemsCount;
    },

    // deliverable-to-shippingAddress mapping to be submitted to backend along with other order data
    shipItemTo: state => {
        var output = {};
        // debugger;
        for (var setIndex in state.items) {
            var set = state.items[setIndex];
            var itemId = 'item_id' in set ? set.item_id : false;
            var isGC = ('gc' in set) ? set.gc : false;
            var dataset = {
                qtys: []
            };
            if (isGC) {
                let k = [setIndex, itemId, 'g'].join('_');
                let addrId = state.selectedAddressId;
                if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                    // previous data input should be preserved
                    addrId = state.addressMap[k];
                }
                if (addrId in state.addresses) {
                    dataset.qtys.push({
                        item_id: itemId,
                        item_index: 'g',
                        address_id: addrId
                    });
                }
            } else {
                if (itemId in state.catalog) {
                    var isComposite = 'composit_item' in state.catalog[itemId] ? state.catalog[itemId].composit_item : false;
                    if (isComposite) {
                        ['parts', 'kscerts'].map((key) => {
                            if (key in state.catalog[itemId]) {
                                for (var partId in state.catalog[itemId][key]) {
                                    let i = 0;
                                    let k = [setIndex, partId, i].join('_');
                                    let addrId = state.selectedAddressId;
                                    if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                                        // previous data input should be preserved
                                        addrId = state.addressMap[k];
                                    }
                                    if (addrId in state.addresses) {
                                        dataset.qtys.push({
                                            item_id: partId,
                                            item_index: i,
                                            address_id: addrId
                                        });
                                    }
                                }
                            }
                        });
                    }
                }
                var qtys = set.children;
                for (let itemId in qtys) {
                    for (var i = 0; i < qtys[itemId]; i++) {
                        let k = [setIndex, itemId, i].join('_');
                        let addrId = state.selectedAddressId;
                        if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                            // previous data input should be preserved
                            addrId = state.addressMap[k];
                        }
                        if (addrId in state.addresses) {
                            dataset.qtys.push({
                                item_id: itemId,
                                item_index: i,
                                address_id: addrId
                            });
                        }
                    }
                }
            }
            if (dataset.qtys.length > 0) {
                output[setIndex] = dataset;
            }
        }
        return output;
    },

    // credit card related
    ccTypes: state => state.creditCard.types,
    ccMonthes: state => state.creditCard.monthes,
    ccYears: state => {
        var output = {};
        for (var i = 0; i < state.creditCard.yearsCount; i++) {
            var yr = (+state.creditCard.yearNow + i).toString();
            output[yr] = yr;
        }
        return output;
    },

    // related to calculations of specific amounts
    subTotal: state => {
        var sum = 0.0;
        var cart = state.items || {};
        for (var cartIndex in cart) {
            var lineItem = cart[cartIndex];
            var prodId = lineItem.item_id || 0;
            var product = state.catalog[prodId] || {};
            var basePrice = +(product.price || 0.0);
            sum += basePrice;
            for (var childId in cart[cartIndex].children || {}) {
                var qty = cart[cartIndex].children[childId];
                var price = +state.catalog[prodId].children[childId].price;
                sum += price * qty;
            }
        }
        return sum;
    },

    taxableAmount: state => {
        var taxable = 0.0;
        var cart = state.items || {};
        var products = state.catalog || {};
        // debugger;
        if (cart.length > 0) {
            for (var itemIndex in cart) {
                var position = cart[itemIndex];
                if ('item_id' in position) {
                    var productId = position.item_id;
                    if (productId in products) {
                        var product = products[productId];
                        if ('taxable_amount' in product) {
                            taxable += +product['taxable_amount'];
                        }
                        if ('children' in position) {
                            for (var itemId in position.children) {
                                var qty = +position.children[itemId];
                                // debugger;
                                if (itemId in product.children) {
                                    if ('taxable_amount' in product.children[itemId]) {
                                        taxable += qty * +product.children[itemId]['taxable_amount'];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        taxable = +taxable.toFixed(2);
        return taxable;
    },

    salesTax: (state, getters) => {
        let salesTax = 0.0;
        const cart = state.items || {};
        if (cart.length > 0) {
            const campaign = state.campaign || {};
            const taxCfg = ('options' in campaign && 'tax' in campaign.options) ? campaign.options.tax : {};
            const isDynamicTaxing = 'type' in taxCfg && taxCfg.type === 'dynamic';
            const isConstTaxing = 'type' in taxCfg && taxCfg.type === 'constant_rate';
            const statesList = 'state_abbr' in taxCfg ? taxCfg.state_abbr : ''; // 'CA' or ['FL','MA']
            const taxableStates = Array.isArray(statesList) ? statesList : ['' + statesList];
            const defaultTaxRate = 'rate' in taxCfg ? +taxCfg.rate : 0.0;
            const taxAddressType = 'address_type' in taxCfg ? taxCfg.address_type : '';
            const isAllTaxingByBilling = taxAddressType === 'billing';
            const isShipToMultiple = state.shipTo === 'ship2multiple';
            const billing = getters.billing;
            const markdown = getters.markdown;
            for (let setIndex in cart) {
                let set = cart[setIndex];
                if ('item_id' in set && set.item_id in markdown) {
                    const itemId = set.item_id;
                    const isGC = ('gc' in set) ? set.gc : false;
                    if (isGC) {
                        let taxRate = defaultTaxRate;
                        if (isDynamicTaxing) {
                            // no taxes are applied for items of gift certificate.
                            // taxes will be applied during gift certificate redemption process
                            continue;
                        } else if (isConstTaxing) {
                            // for base product first
                            let taxable = 0.0;
                            let product = markdown[itemId];
                            if ('taxable_amount' in product) {
                                taxable = +product['taxable_amount'];
                                salesTax += taxable * taxRate;
                            }
                            let qtys = set.children; // for dependent products
                            let children = 'children' in markdown[itemId] ? markdown[itemId].children : {};
                            for (let childId in qtys) {
                                let taxable = 0.0;
                                let product = childId in children ? children[childId] : {};
                                if ('taxable_amount' in product) {
                                    taxable = +product['taxable_amount'];
                                }
                                let qty = qtys[childId];
                                salesTax += taxable * taxRate * qty;
                            }
                        } else {
                            let addrId = isShipToMultiple ? 0 : state.selectedAddressId;
                            if (isShipToMultiple) {
                                let k = [setIndex, itemId, 'g'].join('_');
                                if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                                    addrId = state.addressMap[k];
                                }
                            }
                            if (addrId in state.addresses) {
                                taxRate = 'total_tax_rate' in state.addresses[addrId]
                                    ? state.addresses[addrId].total_tax_rate
                                    : 0.0;
                            }
                            taxRate += taxRate; // a stub for eslint
                        }
                    } else {
                        var isComposite = 'composit_item' in markdown[itemId] ? markdown[itemId].composit_item : false;
                        if (isComposite && 'parts' in markdown[itemId]) {
                            for (let partId in markdown[itemId].parts) {
                                let taxable = 0.0;
                                let product = markdown[itemId].parts[partId];
                                if ('taxable_amount' in product) {
                                    taxable = +product['taxable_amount'];
                                }
                                let taxRate = defaultTaxRate;
                                if (isDynamicTaxing) {
                                    if (isAllTaxingByBilling) {
                                        taxRate = 'total_tax_rate' in billing ? billing.total_tax_rate : 0.0;
                                        taxRate = 'state_prov' in billing &&
                                        taxableStates.indexOf(billing.state_prov) !== -1 ? taxRate : 0.0;
                                    } else {
                                        let addrId = isShipToMultiple ? 0 : state.selectedAddressId;
                                        if (isShipToMultiple) {
                                            const i = 0;
                                            let k = [setIndex, partId, i].join('_');
                                            if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                                                addrId = state.addressMap[k];
                                            }
                                        }
                                        if (addrId in state.addresses) {
                                            taxRate = 'total_tax_rate' in state.addresses[addrId]
                                                ? state.addresses[addrId].total_tax_rate
                                                : 0.0;
                                        }
                                    }
                                }
                                salesTax += taxable * taxRate;
                            }
                        }
                        let taxable = 0.0;
                        let product = markdown[itemId];
                        if ('taxable_amount' in product) {
                            taxable = +product['taxable_amount'];
                        }
                        let taxRate = defaultTaxRate;
                        if (isDynamicTaxing) {
                            if (isAllTaxingByBilling) {
                                taxRate = 'total_tax_rate' in billing ? billing.total_tax_rate : 0.0;
                                taxRate = 'state_prov' in billing &&
                                taxableStates.indexOf(billing.state_prov) !== -1 ? taxRate : 0.0;
                            } else {
                                let addrId = isShipToMultiple ? 0 : state.selectedAddressId;
                                if (isShipToMultiple) {
                                    const i = 0;
                                    let k = [setIndex, itemId, i].join('_');
                                    if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                                        addrId = state.addressMap[k];
                                    }
                                }
                                if (addrId in state.addresses) {
                                    taxRate = 'total_tax_rate' in state.addresses[addrId]
                                        ? state.addresses[addrId].total_tax_rate
                                        : 0.0;
                                }
                            }
                        }
                        salesTax += taxable * taxRate;

                        var qtys = set.children;
                        var children = 'children' in markdown[itemId] ? markdown[itemId].children : {};
                        for (let childId in qtys) {
                            let taxable = 0.0;
                            let product = childId in children ? children[childId] : {};
                            if ('taxable_amount' in product) {
                                taxable = +product['taxable_amount'];
                            }
                            for (let i = 0; i < qtys[childId]; i++) {
                                let taxRate = defaultTaxRate;
                                if (isDynamicTaxing) {
                                    if (isAllTaxingByBilling) {
                                        taxRate = 'total_tax_rate' in billing ? billing.total_tax_rate
                                            : 0.0;
                                        taxRate = 'state_prov' in billing &&
                                        taxableStates.indexOf(billing.state_prov) !== -1 ? taxRate : 0.0;
                                    } else {
                                        let addrId = isShipToMultiple ? 0 : state.selectedAddressId;
                                        if (isShipToMultiple) {
                                            const j = i;
                                            let k = [setIndex, childId, j].join('_');
                                            if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                                                addrId = state.addressMap[k];
                                            }
                                        }
                                        if (addrId in state.addresses) {
                                            taxRate = 'total_tax_rate' in state.addresses[addrId]
                                                ? state.addresses[addrId].total_tax_rate
                                                : 0.0;
                                        }
                                    }
                                }
                                salesTax += taxable * taxRate;
                            }
                        }
                    }
                }
            }
        }
        salesTax = round(+salesTax, 2, 'PHP_ROUND_HALF_UP');
        return salesTax;
    },

    // promotional discounts
    markdown: state => {
        // it calculates discounted values of 'price' and 'taxable amount' for each item in the catalog
        const cart = state.items || {};
        const promo = state.promo || {};
        const products = state.catalog || {};

        let catalog = {};

        if (cart.length > 0) {
            for (let id in products) {
                const prod = products[id];
                const children = prod['children'] || [];
                let position = Object.assign({}, prod, {children: {}});
                for (let i in children) {
                    if ('item_id' in children[i]) {
                        position['children'][children[i]['item_id']] = refreshPrices(promo, children[i]);
                    }
                }
                catalog[id] = refreshPrices(promo, position);
            }
        }
        return catalog;
    },

    promoDiscount: (state, getters) => {
        const promo = state.promo || {};
        const products = state.catalog || {};
        const cart = state.items || {};

        let sum = 0.0;
        let promoDiscount = 'promo_discount' in promo ? promo['promo_discount'] : 0.0;

        if ('promo_type' in promo) {
            if (promo['promo_type'] === 'fixed') {
                // just an amount of money - no additional handling
                sum = +promoDiscount;
            } else if (promo['promo_type'] === 'percentage') {
                // each item's price becomes dependable of this discount
                if (cart.length > 0) {
                    // debugger;
                    for (let itemIndex in cart) {
                        const position = cart[itemIndex];
                        if ('item_id' in position) {
                            const productId = position.item_id;
                            if (productId in products) {
                                const product = products[productId];
                                if ('price' in product) {
                                    sum += +product['price'] * promoDiscount;
                                }
                                // NB: we need to skip adding a donation amount here
                                if ('children' in position) {
                                    for (let itemId in position.children) {
                                        let qty = +position.children[itemId];
                                        if ('children' in product && itemId in product['children']) {
                                            const child = product['children'][itemId];
                                            if ('price' in child) {
                                                const price = +child['price'];
                                                sum += qty * price * promoDiscount;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (promo['promo_type'] === 'dynamic') {
                if (cart.length > 0) {
                    for (let itemIndex in cart) {
                        const position = cart[itemIndex];
                        if ('item_id' in position) {
                            const productId = position.item_id;
                            if (productId in products && productId in getters.markdown) {
                                let price = 0.0;
                                const product = products[productId];
                                if ('price' in product) {
                                    price = +product['price'];
                                }
                                let discountedPrice = 0.0;
                                const markdown = getters.markdown[productId];
                                if ('price' in markdown) {
                                    discountedPrice = +markdown['price'];
                                }
                                if (price > discountedPrice) {
                                    sum += price - discountedPrice;
                                }
                                if ('children' in position) {
                                    for (let itemId in position.children) {
                                        const qty = +position.children[itemId];
                                        if (qty > 0 && 'children' in product && itemId in product['children'] &&
                                            'children' in markdown && itemId in markdown.children
                                        ) {
                                            price = 0.0;
                                            const item = product['children'][itemId];
                                            if ('price' in item) {
                                                price = +item['price'];
                                            }
                                            discountedPrice = 0.0;
                                            const md = markdown.children[itemId];
                                            if ('price' in md) {
                                                discountedPrice = +md['price'];
                                            }
                                            if (price > discountedPrice) {
                                                sum += qty * (price - discountedPrice);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        sum = round(+sum, 2, 'PHP_ROUND_HALF_UP');
        return sum;
    }
}

// actions
const actions = {
}

// promo helper
function refreshPrices (promo, item) {
    let result = Object.assign({'price': 0.0, 'taxable_amount': 0.0, 'item_type': 0}, item);
    const isPromoPercentage = 'promo_type' in promo && promo['promo_type'] === 'percentage';
    const promoPercentage = isPromoPercentage && 'promo_discount' in promo ? +promo['promo_discount'] : 0.0;
    const isPromoDynamic = 'promo_type' in promo && promo['promo_type'] === 'dynamic';
    if (isPromoPercentage) {
        Object.assign(result, {
            'price': result['price'] - result['price'] * promoPercentage,
            'taxable_amount': result['taxable_amount'] - result['taxable_amount'] * promoPercentage
        });
    } else if (isPromoDynamic) {
        const options = ('options' in promo) ? promo.options : {};
        for (let id in options) {
            const opt = options[id];
            if ('item_type' in opt && opt.item_type === item.item_type) {
                if ('promo_type' in opt) {
                    let optPromoType = opt['promo_type'];
                    const except = ('except' in opt) ? opt.except : {};
                    const exceptions = Object.assign({'item_group': 0}, except);
                    if (exceptions['item_group'] > 0) {
                        if (exceptions['item_group'] === result['item_number'] ||
                            exceptions['item_group'] === result['parent']
                        ) {
                            optPromoType = '';
                        }
                    }
                    switch (optPromoType) {
                    case 'percentage':
                        if ('promo_discount' in opt && opt['promo_discount'] >= 0.01) {
                            Object.assign(result, {
                                'price': result['price'] - result['price'] * opt['promo_discount'],
                                'taxable_amount': result['taxable_amount'] - result['taxable_amount'] * opt['promo_discount']
                            });
                        }
                        break;
                    case 'fixed':
                        if ('promo_discount' in opt && opt['promo_discount'] >= 0.01) {
                            Object.assign(result, {
                                'price': result['price'] - opt['promo_discount'],
                                'taxable_amount': result['taxable_amount'] - opt['promo_discount']
                            });
                        }
                        break;
                    }
                }
            }
        }
    }
    return result;
}

// mutation helpers
function toUpperCaseAll (campaign, lines) {
    let options = campaign.options || {};
    let inscription = options.inscription || {};
    let isAllUppercase = inscription.is_all_uppercase || false;
    if (isAllUppercase) {
        Object.keys(lines).map(function (key) {
            lines[key] = lines[key].toString().toUpperCase();
        });
    }
    return lines;
}

function unpackCssData (items) {
    // unpack text of "ui_class" column for Vue.js-based style binding
    Object.keys(items).map(function (key) {
        var item = items[key];
        var uiClasses = item.ui_class || {};
        var classes = {};
        for (let k of uiClasses.split(' ')) {
            classes[k] = true;
        }
        item[key] = Object.assign(item, { classes });
    });
}

// mutations
const mutations = {
    // mobile navigation menu
    openExpander (state) {
        state.navExpanderOpen = true;
    },
    closeExpander (state) {
        state.navExpanderOpen = false;
    },

    initAllFromApi (state, { campaign, product, countries, states, yearNow, ccTypes }) {
        state.campaign = campaign || {};

        var catalog = product || {};
        Object.keys(catalog).map(function (key) {
            var children = catalog[key].children || {};
            unpackCssData(children);
        });
        unpackCssData(catalog);

        state.catalog = product || {};
        state.countries = countries || {};
        state.regions = states || {};
        state.creditCard.yearNow = yearNow;
        state.creditCard.types = ccTypes;
    },
    addItemToCart (state, item) {
        let campaign = state.campaign || {};
        let lines = item.lines || {};
        state.items.push(Object.assign(
            {}, item, { lines: toUpperCaseAll(campaign, lines) }
        ));
    },
    updateInscription (state, { cartId, lines }) {
        let campaign = state.campaign || {};
        let cart = state.items;
        if (cartId in cart) {
            cart[cartId].lines = toUpperCaseAll(campaign, lines);
            state.items = Object.assign([], cart);
        }
    },
    updatePreferredLocation (state, { cartId, location }) {
        let cart = state.items;
        if (cartId in cart) {
            if ('gc' in cart[cartId] && cart[cartId].gc === false) {
                cart[cartId].options = Object.assign({}, cart[cartId].options, { location: location });
                state.items = Object.assign([], cart);
            }
        }
    },
    updatePreferredLogo (state, { cartId, logo }) {
        let cart = state.items;
        if (cartId in cart) {
            if ('gc' in cart[cartId] && cart[cartId].gc === false) {
                cart[cartId].options = Object.assign({}, cart[cartId].options, { logo: logo });
                state.items = Object.assign([], cart);
            }
        }
    },
    deleteItemFromCart (state, index) {
        // to form new array without an element of old array with specified index
        state.items = state.items.filter(function (item, idx) {
            return idx !== index;
        });
    },
    changeItemQtyInCart (state, {itemIndex, childId, delta}) {
        var itemChildren = 'children' in state.items[itemIndex] ? state.items[itemIndex].children : {};
        var qty = childId in itemChildren ? itemChildren[childId] : -1;
        var newValue = qty + delta;
        if (newValue >= 0) {
            state.items[itemIndex].children[childId] = newValue;
        }
    },
    updateMarketingInfo (state, marketing) {
        state.marketing = marketing;
    },
    updateBillingAddress (state, billing) {
        if (state.billingAddressId in state.addresses) {
            state.addresses[state.billingAddressId] = Object.assign({}, billing, { address_id: state.billingAddressId });
        }
    },
    setShipToBilling (state) {
        state.shipTo = 'ship2billing';
        state.selectedAddressId = state.billingAddressId;
    },
    setAnotherAddress (state, address) {
        let addrId = +new Date();
        let addresses = state.addresses;
        addresses[addrId] = Object.assign({}, address, { address_id: addrId });
        state.addresses = Object.assign({}, addresses);
        state.shipTo = 'ship2another';
        state.selectedAddressId = addrId;
    },
    addNewAddress (state, address) {
        let addrId = +new Date();
        let addresses = state.addresses;
        addresses[addrId] = Object.assign({}, address, { address_id: addrId });
        state.addresses = Object.assign({}, addresses);
    },
    completeTheInvoice (state, invoice) {
        state.orderId = invoice.order || 0;
        state.tokenKey = invoice.key || '';
        state.ipAddr = invoice.ip || '127.0.1.1';
        state.quantum = Object.assign({}, state.quantum, invoice.quantum || {});
    },
    completePayment (state, payment) {
    },
    completeTheOrder (state) {
        state.orderId = 0;
        state.isOrderCompleted = true;
        if (state.shipTo !== 'ship2multiple') {
            Object.keys(state.addressMap).map(function (key) {
                state.addressMap[key] = state.selectedAddressId;
            });
        }
    },
    clearCompletedOrder (state) {
        state.items = Object.assign([]);
        state.isOrderCompleted = false;
        state.orderId = 0;
        // reset to defaults:
        state.addressMap = {};
        state.shipTo = 'ship2billing';
    },
    populateAddressMap (state, shipItemTo) {
        var map = {};
        for (var setIndex in shipItemTo) {
            var qtys = shipItemTo[setIndex]['qtys'];
            for (var i = 0; i < qtys.length; i++) {
                if ('item_id' in qtys[i] && 'address_id' in qtys[i]) {
                    var itemId = qtys[i]['item_id'];
                    var itemIndex = qtys[i]['item_index'];
                    var k = [setIndex, itemId, itemIndex].join('_');
                    if ('address_id' in qtys[i] && qtys[i].address_id in state.addresses) {
                        map[k] = qtys[i]['address_id'];
                    }
                }
            }
        }
        state.addressMap = Object.assign({}, map);
        state.shipTo = 'ship2multiple';
        state.selectedAddressId = 0;
    },
    applyPromoCode (state, promo) {
        let data = {
            promo_code: promo.promo_code || '',
            promo_discount: promo.promo_discount || 0.0,
            promo_type: promo.promo_type || 'fixed',
            options: promo.options || []
        };
        state.promo = Object.assign({}, data);
    }
}

/* eslint-disable no-new */
export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js